// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ee52621","453":"133f2cf2","455":"8f3c5805","977":"2ccb729f"}[chunkId] + ".chunk.js";
};